/*
  2026-10-08 (Luis): wiring for the Todo / Hombre / Mujer switch
  (snippets/ss-genero-switch). The state helpers live inline in
  layout/theme.liquid as window.ssGenero, so a covered collection reloads
  filtered before it paints. Here:
  - every [data-ss-gen] shows the current choice; a click saves it and, on a
    covered collection, reopens the page with the new filter;
  - links to New In, Ropa, Zapatos and Accesorios carry the filter, except the
    ones inside the facets and the pagination and links that already pick a
    gender;
  - 'ss:genero' tells the home rails (assets/ss-brand-rail.js) to refetch;
  - Para ti ([data-ss-gen-local], a fixed list from the customer's profile)
    hides the cards whose custom.para (data-para) leaves out the choice;
  - PostHog gets genero_switch with the choice and where it was made;
  - on a phone, once the page's switch scrolls under the header, a copy of it
    sticks right below the header (Luis, 2026-10-08, like the product page's
    sticky bar), so the choice is always at hand.
*/
(function () {
  var G = window.ssGenero;
  if (!G) return;
  var here = G.handle(location.href);
  var SKIP = '.facets-wrapper, facet-filters-form, .active-facets, .pagination, [data-ss-gen-skip]';

  // On a covered collection the URL decides (null for a mix picked in the facets).
  function shown() {
    return here ? G.fromUrl(location.href) : G.get();
  }

  function paint(v) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-gen] [data-gen]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-gen') === v ? 'true' : 'false');
    });
  }

  function rewrite(v) {
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="/collections/"]'), function (a) {
      if (a.closest(SKIP)) return;
      var orig = a.getAttribute('data-ss-gen-href');
      if (orig === null) {
        orig = a.getAttribute('href');
        if (!orig || !G.handle(orig) || G.has(orig)) return;
        a.setAttribute('data-ss-gen-href', orig);
      }
      var u = G.apply(orig, v, true);
      a.setAttribute('href', u.pathname + u.search + u.hash);
    });
  }

  // Para ti is built from the profile, not fetched: filter its cards in place.
  // A card without data-para stays (the hourly job has not reached it yet).
  function filterLocal(v) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-gen-local] li[data-para]'), function (li) {
      var para = (li.getAttribute('data-para') || '').split(' ');
      li.hidden = v !== 'todo' && para[0] !== '' && para.indexOf(v) < 0;
    });
  }

  function choose(v) {
    G.set(v);
    if (window.posthog && posthog.capture) {
      posthog.capture('genero_switch', { value: v, where: here ? 'collection' : 'home', path: location.pathname });
    }
    if (here) {
      location.href = G.apply(location.href, v).toString();
      return;
    }
    paint(v);
    rewrite(v);
    filterLocal(v);
    document.dispatchEvent(new CustomEvent('ss:genero', { detail: { value: v } }));
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ss-gen] [data-gen]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-pressed') === 'true') return;
    choose(b.getAttribute('data-gen'));
  });

  // Phone: a copy of the page's switch pinned under the header while the
  // original is out of sight. Same buttons, so paint() and the click handler
  // above cover it. Checked on every scroll frame and whenever the header
  // changes height (the logo shrinks): an IntersectionObserver fired once,
  // while the switch was still half under the header, and a finger scroll
  // never showed the bar (Luis, 2026-10-08).
  // The bar copies the page's switch and shows once its anchor is under the
  // header: the switch itself, or on the home's phone layout (switch hidden)
  // the NEW IN / MENOS DE row ([data-ss-gen-anchor]).
  function stick() {
    var all = document.querySelectorAll('[data-ss-gen]');
    var src = Array.prototype.filter.call(all, function (el) {
      return el.getClientRects().length > 0;
    })[0];
    var anchor = src || document.querySelector('[data-ss-gen-anchor]');
    src = src || all[0];
    if (!src || !anchor) return;
    var bar = document.createElement('div');
    bar.className = 'ss-gen-sticky';
    bar.setAttribute('aria-hidden', 'true');
    var copy = src.cloneNode(true);
    copy.className = 'ss-gen ss-gen--home';
    Array.prototype.forEach.call(copy.querySelectorAll('button'), function (b) { b.tabIndex = -1; });
    bar.appendChild(copy);
    document.body.appendChild(bar);
    var header = document.querySelector('.section-header');
    var on = false;
    var queued = false;
    function place() {
      queued = false;
      var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      bar.style.top = top + 'px';
      var gone = anchor.getBoundingClientRect().bottom <= top;
      if (gone === on) return;
      on = gone;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(place);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (header && 'ResizeObserver' in window) new ResizeObserver(queue).observe(header);
    place();
  }

  function boot() {
    paint(shown());
    rewrite(G.get());
    filterLocal(G.get());
    stick();
    // The facets re-render the grid and push a new URL (assets/facets.js):
    // follow it, e.g. after "Borrar todo".
    var grid = here && document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { paint(shown()); }).observe(grid, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
